import { neutral } from '../global';
export const line = {
    primary: neutral[86],
};
//# sourceMappingURL=default.js.map
